module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"personalDataIcons":{"changeName":"Name\\nändern","changeAddress":"Adresse\\nändern","changeBankData":"Bankdaten\\nändern"}}}')
  delete Component.options._Ctor
}
